import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {FormBaseComponent, NavigationService, ValidatorService} from '@utils-lib';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {PersonenstammDaten} from '@nachdigal';


@Component({
    selector: 'common-ui-personenstamm-daten',
    templateUrl: './personenstamm-daten.component.html'
})
export class PersonenstammDatenComponent extends FormBaseComponent<PersonenstammDaten> implements OnInit{

    @Input()
    public affectNavigationInfo = false;

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                protected readonly messageService: DatevMessageService,
                public readonly navigationService: NavigationService) {
        super(messageService);
    }

  public ngOnInit(): void {
    super.ngOnInit();
    this.onNameChange();
  }

    public onNameChange(): void {
        if (this.affectNavigationInfo) {
            this.navigationService.onMandantNameUpdated(this.data.nachname, this.data.vorname);
        }
    }

    protected createForm(): void {
      const minLength = 1;
      const maxLengthTitel = 30;
      const maxLengthName = 72;
      const maxLengthNamensvorsatz = 25;
      const maxLengthNamenszusatz = 60;
      this.form = this.formBuilder.group({
            titel: [this.data.titel, [
                this.validatorService.minLength(minLength),
                this.validatorService.maxLength(maxLengthTitel)
            ]],
            vorname: [this.data.vorname, [
                this.validatorService.required(),
                this.validatorService.minLength(minLength),
                this.validatorService.maxLength(maxLengthName)
            ]],
            nachname: [this.data.nachname, [
                this.validatorService.required(),
                this.validatorService.minLength(minLength),
                this.validatorService.maxLength(maxLengthName)
            ]],
            namensvorsatz: [this.data.namensvorsatz, [
                this.validatorService.minLength(minLength),
                this.validatorService.maxLength(maxLengthNamensvorsatz)
            ]],
            namenszusatz: [this.data.namenszusatz, [
                this.validatorService.minLength(minLength),
                this.validatorService.maxLength(maxLengthNamenszusatz)
            ]]
        });
    }

}
